"use strict";
const set = /* @__PURE__ */ new Set(["mp3", "wav"]);
export const isAudio = (file) => {
  if (!file) {
    return false;
  }
  const fileType = file.substring(file.lastIndexOf(".") + 1);
  return set.has(fileType);
};
